import React, { useState } from 'react';
import api from 'helpers/api';
import notification from 'helpers/notification';
import Button from '../../components/button';
import useGym from 'helpers/use_gym';

const BulkApplyDefaultEventSettingsModal = ({ modalInstance, endpoint, change }) => {
  const [isLoading, setIsLoading] = useState(false);
  const gym = useGym();

  const close = () => {
    modalInstance.dismiss('cancel');
  };

  const save = () => {
    setIsLoading(true);
    const url = `gyms/${gym.id}/${endpoint}`;

    api.put(url).then(
      () => {
        notification.success('Updated successfully');
        modalInstance.close();
      },
      () => {
        setIsLoading(false);
        notification.error('Request could not be completed. Please try again');
      },
    );
  };

  return (
    <div>
      <div className="modal-header">
        <a aria-hidden="true" className="close-modal" onClick={close} title="Close">
          <i className="icon-cross"></i>
        </a>
        <h4 className="modal-title">Bulk-apply default event settings</h4>
      </div>
      <div className="modal-body modal-body-visible">
        <p>
          This action will apply the following settings change to all events that currently exist in
          your calendar:
        </p>
        <ul>
          <li dangerouslySetInnerHTML={{ __html: change }} />
        </ul>
        <p>To proceed, click "Continue" below.</p>
      </div>
      <div className="modal-footer">
        <Button onClick={close}>Cancel</Button>
        <Button variant="success" disabled={isLoading} onClick={save}>
          Continue
        </Button>
      </div>
    </div>
  );
};

angular
  .module('gym')
  .value('BulkApplyDefaultEventSettingsModal', BulkApplyDefaultEventSettingsModal);
